<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-card class="mt-2 col-12">
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode)"
          >
            <b-col cols="12">
              <SearchFilter
                ref="searchFilter"
                :routeName="$route.name"
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-card v-for="tab in activeTab" :id="tab" :key="tab">
        <commonTable
          ref="tableCommon"
          :routeName="$route.name"
          :tableHeader="tableHeader"
          :searchMode="tab"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        />
      </b-card>
    </b-overlay>
    <ModalNotification
      ref="ModalNotification"
      :complaints="notificationComplaints"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import commonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import commonTableHeader from "@/views/Complaint/components/vueGoodTable/commonTableHeader.js";
import SearchFilter from "@/views/Complaint/components/vueGoodTable/SearchFilter.vue";
import * as viewStore from "@/store/api/screening/screening.js";
import ModalNotification from "../components/ModalNotification.vue";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    commonTable,
    SearchFilter,
    ModalNotification,
  },
  data() {
    return {
      tabs: [
        { title: "รายการเรื่องร้องทุกข์", mode: "Deptlist" },
        { title: "ประวัติดำเนินการ", mode: "UserHistory" },
      ],
      activeTab: ["Deptlist"],
      tableHeader: commonTableHeader,
      notificationComplaints: [],
      showOverlay: false,
    };
  },
  //COMPLAINT-486 เอา popup แจ้งเรื่องเข้ากอง ของธุรการกองออก
  // created() {
  //   this.getComplaintNotification();
  // },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    getManageGroup(id) {
      if (this.activeTab[0] == "UserHistory") {
        const routeData = this.$router.resolve({
          name: "ComplaintHistoryDetail",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      } else {
        const routeData = this.$router.resolve({
          name: "DeptlistRecieve",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      }
    },
    searchFilterSubmit(params) {
      params.departmentId = userData.departmentId();

      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    getComplaintNotification() {
      const _this = this;

      const params = {
        departmentId: userData.departmentId(0),
      };
      viewStore
        .getComplaintForNotiAdmin(params)
        .then((response) => {
          console.log("data", response.data.data);
          if (response.data.data.totalresult > 0) {
            _this.notificationComplaints = response.data.data.listForNewcase;

            _this.$refs.ModalNotification.$refs["modal-notification"].show();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
